import { Box, Text, Image, Flex, Skeleton } from "@chakra-ui/react";
import { Release, DisplayFlags, LayoutStyle } from "../../types";
import { getReleaseTypeName } from "../../utils/getReleaseTypeName";
import { ExtendedContentCardBackdrop } from "./components/ContentCardBackdrop";
import { GridCardWrapper } from "./components/GridCardWrapper";
import { PriceAndStrikePriceLabel } from "./components/PriceAndStrikePriceLabel";

interface YearlyBundleReleaseCardProps {
  content: Release;
  layout: {
    display: DisplayFlags;
    style: LayoutStyle;
  };
}

export function YearlyBundleReleaseCard({
  content,
  layout,
}: YearlyBundleReleaseCardProps) {
  const { display, style } = layout;

  return (
    <GridCardWrapper layout={{ display, style }} noPointer>
      <>
        <ExtendedContentCardBackdrop
          position="absolute"
          bottom="0px"
          h="calc(100% - 63px)"
          topBox={{
            height: "63px",
          }}
          bottomBox={{
            height: "calc(100% - 63px)",
          }}
        />

        <Box className="card-img-wrapper" aspectRatio=".646">
          <Image
            src={content.thumbnail_url}
            borderRadius={10}
            border="1px solid"
            borderColor="transparent.white.10"
            width="100%"
            aspectRatio=".646"
            alt={`Cover image for ${content.localized_comic_name}`}
            fallback={
              <Skeleton width="100%" aspectRatio=".646" borderRadius={10} />
            }
          />
        </Box>

        <Flex direction="column" position="relative" width="100%">
          <Text variant="cardSubtitle" color="charcoal.200" noOfLines={1}>
            {getReleaseTypeName(content)} #{content.chapter}
          </Text>

          <Text variant={"cardHeader"} noOfLines={1}>
            {content.title}
          </Text>

          <Box pt="4px">
            <PriceAndStrikePriceLabel
              strokePrice={
                content.ppb_price_point
                  ? content.ppb_price_point / 100
                  : undefined
              }
              isOnSale={true}
              fontSize="14px"
              displayAsAColumn
              showIncludedLabel
            />
          </Box>
        </Flex>
        <Flex
          direction="column"
          gap={2}
          alignItems="start"
          width="100%"
          position="relative"
        ></Flex>
      </>
    </GridCardWrapper>
  );
}
